import { render, staticRenderFns } from "./InsuranceProducts.vue?vue&type=template&id=a4d5085c"
import script from "./InsuranceProducts.vue?vue&type=script&lang=js"
export * from "./InsuranceProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports